<div class="card-header d-flex justify-content-between collapsed" [attr.id]="'heading-' + name" (click)="toggleExpander($event)" aria-expanded="false" [attr.aria-controls]="'collapse-' + name">
  <h5 class="mb-0">{{ criteria.required ? 'Required' : 'Optional' }}
    <ng-container *ngIf="form?.value">
      <ng-container *ngIf="criteria.required">
        <span class="badge rounded-pill" [ngClass]="{ 'selected': criteriaFilters['unknown'] }" (click)="toggleBadge($event, 'unknown')">{{ criteria.criteriaUnknown }} Unanswered</span>
        <span class="badge rounded-pill" [ngClass]="{ 'selected': criteriaFilters[criteria.criteriaMatchType] }" (click)="toggleBadge($event, criteria.criteriaMatchType)">{{ criteria.criteriaMatched }} {{ criteria.inclusion ? 'Yes' : 'No'}}</span>
        <span class="badge rounded-pill" [ngClass]="{ 'selected': criteriaFilters[criteria.criteriaNoMatchType] }" (click)="toggleBadge($event, criteria.criteriaNoMatchType)">{{ criteria.criteriaNotMatched }} {{ criteria.inclusion ? 'No' : 'Yes'}}</span>
      </ng-container>
      <span *ngIf="!criteria.required">{{ criteriaMatched }} of {{ form?.value.item.length }} met</span>
    </ng-container>
  </h5>
  <i aria-hidden="true"></i>
</div>
<div [attr.id]="'collapse-' + criteria?.expanderID" class="collapse" [attr.aria-labelledby]="'heading-' + name">
    <ng-container *ngIf="form">
      <div class="card-body" [formGroup]="form">
        <ul class="criterion-list" formArrayName="item">
          <ng-container *ngFor="let itemForm of itemFormArray.controls; let i = index;">
            <li appCriterion [ngClass]="{ 'd-none': (criteria.required && !criteriaFilters[getCriteriaCode(itemForm)]) }" [parentControl]="itemForm" [formGroupName]="i" [index]="i" [inclusion]="criteria.inclusion" [label]="criteria.criteriaLabels[i].label"></li>
          </ng-container>
        </ul>
      </div>
    </ng-container>
    <ng-container *ngIf="!form">
      <div class="card-body">
        <h6>There are currently no criteria for this section.</h6>
      </div>
    </ng-container>
</div>
